import { render, staticRenderFns } from "./SingleCustomer.vue?vue&type=template&id=78f11472&scoped=true&"
import script from "./SingleCustomer.vue?vue&type=script&lang=ts&"
export * from "./SingleCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./SingleCustomer.vue?vue&type=style&index=0&id=78f11472&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f11472",
  null
  
)

export default component.exports